// extracted by mini-css-extract-plugin
module.exports = {"Brands":"BrandsBlock_Brands__1Ykcp"};